<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="driver-list">
    <div v-for="item in list" :key="item.id">
      <div class="driver-item" @click="chooseActions(item.id,item.bpmStatus)">
        <div class="driver-item-content">
          <span class="driver-name">姓名:{{item.name}}</span>
          <div class="bpm-status" v-if="item.bpmStatus == 1">
            <van-tag type="danger">未提交</van-tag>
          </div>
          <div class="bpm-status" v-else-if="item.bpmStatus == 2">
            <van-tag type="warning">审核中</van-tag>
          </div>
          <div class="bpm-status" v-else-if="item.bpmStatus == 3">
            <van-tag type="primary">审核成功</van-tag>
          </div>
          <div class="content-item first-item">联系电话:{{item.telphone}}</div>
          <div class="content-item">身份证:{{item.shenfenzheng}}</div>
          <div class="content-item">驾驶证截至日期:{{item.jiashizhengyxq}}</div>
          <div class="content-item">从业资格证截至日期:{{item.congyezigeyxq}}</div>
        </div>
        <p class="driver-item-desc">详细信息</p>
      </div>
    </div>
  </div>

  <div v-show="isShowBtn">
    <div class="add-driver-box">
      <van-button round type="info" @click="beianJsz" class="addBtn">
        新增驾驶员备案
      </van-button>
      <van-button round type="info" @click="refreshJsz" class="refreshBtn">
        刷新
      </van-button>
    </div>
  </div>

  <van-action-sheet v-model="actionShow" :actions="actions" cancel-text="取消" close-on-click-action @select="onSelect" />
</div>
</template>
<script>
import api from "@/fetch/api"
import Nav from "../Public/navTpl.vue"
import {
  Toast,
  Dialog,
} from 'vant';
export default {
  inject: ['reload'],
  components: {
    Nav,
  },
  data() {
    return {
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      isShowBtn: true,
      list: [],
      actionShow: false,
      actions: [{
        name: '查看'
      }, {
        name: '编辑'
      }, {
        name: '删除'
      }],
    }
  },
  created() {
    document.title = "驾驶员备案";
    var that = this;
    var openid = that.$store.state.wx_info.openid;
    that.getDriverByOpenid(openid);
  },
  methods: {
    beianJsz() {
      var that = this;
      that.$router.push({
        name: 'adddriver'
      })
    },
    refreshJsz() {
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      that.getDriverByOpenid(openid);
      setTimeout(() => {
        Toast.clear();
      }, 500);
    },
    getDriverByOpenid(openid) {
      var that = this;
      api.getDriverByOpenid(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          that.$data.list = resData.data
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            that.$router.push({
              name: 'index'
            })
          });
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');

      });
    },
    editBeian(id) {
      var that = this;
      that.$router.push({
        name: 'editdriver',
        params: {
          id: id
        }
      })
    },
    deleteBeian(id) {
      var that = this;
      Dialog.confirm({
          message: '是否确认删除备案信息',
        })
        .then(() => {
          let formData = new FormData();
          formData.append("id", id);
          api.deleteBeianJsy(formData).then(function(res) {
            var resData = JSON.parse(res);
            var resMessage = "";
            if (resData.respCode == "0") {
              resMessage = '操作成功';
            } else {
              resMessage = resData.message;
            }

            Dialog.alert({
              message: resMessage,
            }).then(() => {
              that.reload();
            });

          }).catch(function(err) {
            console.log(err);
            Toast.fail('连接失败，请刷新页面');

          });
        })
        .catch(() => {
          // on cancel
        });
    },
    stopBeian(id) {
      var that = this;
      Dialog.confirm({
          message: '是否确认删除备案信息',
        })
        .then(() => {
          let formData = new FormData();
          formData.append("id", id);
          api.stopBeianJsy(formData).then(function(res) {
            var resData = JSON.parse(res);
            var resMessage = "";
            if (resData.respCode == "0") {
              resMessage = '操作成功';
            } else {
              resMessage = resData.message;
            }

            Dialog.alert({
              message: resMessage,
            }).then(() => {
              that.reload();
            });

          }).catch(function(err) {
            console.log(err);
            Toast.fail('连接失败，请刷新页面');

          });
        })
        .catch(() => {
          // on cancel
        });
    },
    submitBeian(id) {
      var that = this;
      Dialog.confirm({
          message: '是否确认提交备案信息',
        })
        .then(() => {
          let formData = new FormData();
          formData.append("id", id);
          api.submitBeianJsy(formData).then(function(res) {
            var resData = JSON.parse(res);
            var resMessage = "";
            if (resData.respCode == "0") {
              resMessage = '操作成功';
            } else {
              resMessage = resData.message;
            }

            Dialog.alert({
              message: resMessage,
            }).then(() => {
              that.reload();
            });

          }).catch(function(err) {
            console.log(err);
            Toast.fail('连接失败，请刷新页面');

          });
        })
        .catch(() => {
          // on cancel
        });
    },
    chooseActions(id, bpmStatus) {
      var that = this;
      that.$data.actionId = id;
      that.$data.bpmStatus = bpmStatus;
      if (bpmStatus == "1") {
        that.$data.actions = [{
          name: '查看'
        }, {
          name: '编辑'
        }, {
          name: '提交审核'
        }, {
          name: '删除'
        }];
      } else if (bpmStatus == "2") {
        that.$data.actions = [{
          name: '查看'
        }, {
          name: '编辑'
        }];
      } else {
        that.$data.actions = [{
          name: '查看'
        }, {
          name: '编辑'
        }, {
          name: '停用'
        }];
      }
      this.actionShow = true;
    },
    onSelect(item) {
      var that = this;
      var actionId = that.$data.actionId;
      var bpmStatus = that.$data.bpmStatus;
      if (actionId) {
        if (item.name == '编辑') {
          if (bpmStatus == 3) {
            Dialog.confirm({
                message: '该驾驶员信息已经审核通过，编辑后需要重新审核，是否进行编辑？',
              })
              .then(() => {
                // on confirm
                that.$router.push({
                  name: 'editdriver',
                  params: {
                    id: actionId
                  }
                })
              })
              .catch(() => {
                // on cancel
              });
          } else {
            that.$router.push({
              name: 'editdriver',
              params: {
                id: actionId
              }
            })
          }

        } else if (item.name == '删除') {
          that.deleteBeian(actionId);
        } else if (item.name == '停用') {
          that.stopBeian(actionId)
        } else if (item.name == '提交审核') {
          that.submitBeian(actionId)
        } else {
          that.$router.push({
            name: 'driverdetail',
            params: {
              id: actionId
            }
          });

        }
      } else {
        Toast('网络异常');
      }
    }

  },

}
</script>
<style lang="scss" scoped>
.driver-list {
    margin-bottom: 4.75rem;
    margin-top: 4.75rem;
    .driver-item {
        margin: 0 1rem 1rem;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        .driver-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 84px;
            padding: 1rem;
            color: #323233;
            .driver-name {
                font-weight: bold;
                font-size: 1rem;
                line-height: 1;
            }
            .content-item {
                line-height: 2;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 0.875rem;
            }

            .first-item {
                margin-top: 0.625rem;
            }
        }
        .driver-item-desc {
            padding: 1rem;
            font-size: 0.875rem;
            border-top: 1px dashed #ebedf0;
        }
    }
}
.bpm-status {
    float: right;
}
.add-driver-box {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
  display: flex;
  gap: 0.5rem;
  .addBtn {
    flex: 1;
  }
  .refreshBtn {
    flex: 1;
    color: #0022ff;
    background-color: #ffeb3b;
    border-color: #ffeb3b;
  }
}

.edit-box {
    width: 100%;
    .edit-info {
        display: inline-block;
        width: 50%;
        float: left;
        .editBtn {
            width: 80%;
            margin: 0 auto;
        }
    }

    .delete-info {
        display: inline-block;
        width: 50%;
        .deleteBtn {
            width: 80%;
            margin: 0 auto;
        }
    }
}
</style>
